import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const studySubjectDiscontinueStatusServices = {
  //Subject Discontinue Status
  addNewStudySubjectDiscontinueStatus,
  updateStudySubjectDiscontinueStatusData,
  deleteStudySubjectDiscontinueStatusData,
  softDeleteRestoreStudySubjectDiscontinueStatus,
  getStudySubjectDiscontinueStatusData,
};

// Add New Study Subject Discontinue Status
async function addNewStudySubjectDiscontinueStatus(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudySubjectDiscontinueStatus`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Subject Discontinue Status
async function updateStudySubjectDiscontinueStatusData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudySubjectDiscontinueStatusData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Subject Discontinue Status
async function softDeleteRestoreStudySubjectDiscontinueStatus(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudySubjectDiscontinueStatus`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Subject Discontinue Status
async function deleteStudySubjectDiscontinueStatusData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudySubjectDiscontinueStatusData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Subject Discontinue Status
async function getStudySubjectDiscontinueStatusData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySubjectDiscontinueStatusData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySubjectDiscontinueStatusData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}